import { Link } from 'react-router'
import { useForm } from 'react-hook-form'
import useTopic from '../../../hooks/useTopics'
import CourseSelectInput from '../../../components/forms/CourseSelectInput'

function QuestionBankPage() {
  const { topics, loading, error } = useTopic()
  const { register, watch } = useForm()

  const selectedCourse = watch('course', '')

  // Filter topics by selected course
  const filteredTopics = selectedCourse
    ? topics.filter(topic => topic.course == selectedCourse)
    : topics

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <span className="loading loading-spinner loading-lg"></span>
      </div>
    )
  }

  if (error) {
    return (
      <div className="text-center text-red-500 py-8">
        {error}
      </div>
    )
  }

  return (
    <div className="max-w-4xl p-6">
      <h1 className="text-2xl font-bold mb-6">Question Bank</h1>
      <form className="mb-4">
        <CourseSelectInput
          name="course"
          label="Filter by Course"
          register={register}
          errors={{}}
          validationRules={{ required: false }}
          fullWidth={false}
        />
      </form>
      {filteredTopics.length === 0 ? (
        <div className="text-center text-gray-500">No topics found.</div>
      ) : (
        <div className="space-y-4">
          {filteredTopics.map(topic => (
            <div
              key={topic.id}
              className="bg-base-100 rounded-lg shadow-sm border border-gray-200 p-5 flex flex-col md:flex-row md:items-center md:justify-between gap-4"
            >
              <div>
                <h2 className="font-semibold text-lg">{topic.title}</h2>
                <div className="text-sm text-gray-600">{topic.description}</div>
                {topic.course_detail && (
                  <div className="text-xs text-gray-400 mt-1">
                    Course: {topic.course_detail.title}
                  </div>
                )}
              </div>
              <Link
                to={`/admin/question-bank/${topic.id}`}
                className="btn btn-primary btn-sm self-start md:self-auto"
              >
                Manage Topic Question Bank
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default QuestionBankPage